export function getTotalPayments(payments) {
  return payments.reduce((sum, payment) => {
    return (sum += payment.amount / 100);
  }, 0);
}



// WEBPACK FOOTER //
// ./src/scenes/ReservationsPage/util.js